<template>
  <div>
    <div class="foot l_o_btm">
      <!-- 总价-->
      <div class="amount"
           @touchstart="show_mx">{{$t('book_amount')}}:
        <span>￥{{getSumMoney()}}</span>
        <i id="mx_angle"
           class="iconfont icon-xia"></i>
      </div>
      <div class="bookbtn"
           @click='book'>{{title}}
      </div>
    </div>
    <!-- 明细弹框 -->
    <mt-popup class="mx_pop-book-footer"
              v-model="mx_popupVisible"
              position="bottom"
              :modal="false">
      <div class="mx-book-footer">
        <div class="count">
          <!-- 费用明细-->
          <span>{{$t('book_count')}}</span>
          <div class="icon"
               @touchstart='hide_mx'>
            <i class="iconfont icon-cuowu"></i>
          </div>
        </div>

        <ul class="mxList">
          <li class="bookingRsvSrcDto"
              v-for='(item, index) in bookingRsvSrcDto'
              v-if='item.rmtype'
              :key="'bookingRsvSrcDto' + index">
            <p class='room-name'>{{$t('book_rmtype')}}：{{item.rmtype}} <span v-if='item.roomName'>--</span>
              {{item.roomName}}</p>
            <template v-if='item.rsvRates && item.rsvRates.length > 0'>
              <div class='everyDayRate'
                   v-for='(item2, index2) in item.rsvRates'
                   :key='"rsvRates" + index2'>
                <span style='display: inline-block;width: 40%;'>{{item2.d | dateMD}}</span>
                <span style='display: inline-block;width: 30%;'
                      v-if='item2.privce != item2.realRate && item2.realRate != ""'>
                  {{$t('book_origin_price')}}：￥{{item2.privce}}
                </span>
                <!-- 房费-->
                <div style='display: inline-block;width: 30%; text-align: right;'>
                  <span>￥{{item2.realRate != '' ?  item2.realRate : item2.privce}} * {{item.rmnum}}</span>
                </div>
              </div>
            </template>

            <template v-else-if='item.everyDayRate && item.everyDayRate.list &&item.everyDayRate.list.length > 0'>
              <div class='everyDayRate'
                   v-for='(item2, index2) in item.everyDayRate.list'
                   :key='"everyDayRate" + index2'>
                <span>{{item2.d | dateMD}}</span>
                <!-- 房费-->
                <div>
                  <span>￥{{item2.privce}} * {{item.rmnum}}</span>
                </div>
              </div>
            </template>
          </li>
        </ul>
      </div>
    </mt-popup>
  </div>
</template>

<script>
  import moment from 'moment';
  import _ from 'lodash';

  export default {
    data() {
      return {
        mx_popupVisible: false
      };
    },
    props: {
      bookInfo: {
        type: Object,
        default: {}
      },
      title: {
        type: String,
        default: ''
      },
      bookingRsvSrcDto: {
        type: Array,
        default: []
      }
    },

    mounted() {
    },

    methods: {
      //底部隐藏费用明细
      hide_mx(e) {
        e.preventDefault();
        this.mx_popupVisible = false;
        document.getElementById('mx_angle').style.transform = 'rotate(0deg)';
      },
      //显示底部费用明细
      show_mx(e) {
        console.log(this.bookingRsvSrcDto)
        if (this.mx_popupVisible == true) {
          this.hide_mx(e);
        } else {
          this.mx_popupVisible = true;
          document.getElementById('mx_angle').style.transform = 'rotate(180deg)';
        }
      },

      getSumMoney() {
        let sum = 0;
        let bookingRsvSrcDto = this.bookingRsvSrcDto || []

        bookingRsvSrcDto.map((item, index) => {
          let rmnum = item.rmnum || 0
          let everyDayRate = item.everyDayRate || {}
          if (item.rsvRates && item.rsvRates.length > 0) {
            item.rsvRates.map((item, index) => {
              if (item.realRate == ''){
                sum += item.privce * rmnum
              } else {
                sum += item.realRate * rmnum
              }
            })
          } else {
            let list = everyDayRate.list || []
            if (list.length > 0) {
              list.map((item, index) => {
                sum += item.privce * rmnum
              })
            }
          }
        })

        // return sum
        return parseFloat(sum).toFixed(2)
      },

      book: _.debounce(function () {
        this.$emit('book')
      }, 500, true),
    },
    filters: {
      dateMD(value) {
        return moment(value, 'YYYY-MM-DD HH:mm:ss').format('MM/DD');
      }
    }
  };
</script>

<style lang="less">
  .foot {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1.2rem;
    background-image: -webkit-linear-gradient(to left, #ff6e61, #f6a12a);
    background-image: -o-linear-gradient(to left, #ff6e61, #f6a12a);
    background-image: linear-gradient(to left, #ff6e61, #f6a12a);
    font-size: 0.42666667rem;
    color: #fff;
    text-align: center;
    z-index: 1000;

    .amount {
      line-height: 1.2rem;
      height: 1.2rem;
      float: left;
      width: 50%;
      box-sizing: border-box;

      .iconfont {
        margin-left: 0.08rem;
        display: inline-block;
        font-size: 0.26666667rem;
      }
    }

    .bookbtn {
      line-height: 1.2rem;
      height: 1.2rem;
      box-sizing: border-box;
      width: 50%;
      padding-left: 1rem;
      float: left;
    }
  }

  .mx_pop-book-footer {
    background: transparent;
    z-index: 100 !important;
    width: 100%;

    .mx-book-footer {
      box-shadow: 0px -0.08rem 0.4rem 0.10666667rem #e8e8e8;
      box-sizing: border-box;
      padding: 0 0.4rem;
      margin-bottom: 1.2rem;
      background: #fff;

      .count {
        height: 1.22666667rem;
        border-bottom: 0.02666667rem solid #e8e8e8;

        span {
          font-size: 0.4rem;
          float: left;
          line-height: 1.22666667rem;
        }

        .icon {
          float: right;

          .iconfont {
            line-height: 1.22666667rem;
            font-size: 0.4rem;
          }
        }
      }

      .mxList {
        font-size: 13px;
        max-height: 80vh;
        overflow-y: scroll;
        padding-bottom: 2rem;
        box-sizing: border-box;

        .bookingRsvSrcDto {
          padding: 0.2rem 0;
          border-bottom: 1px dashed #ddd;

          .room-name {
            font-size: 13px;
            color: #000;
            padding: 10px 0;
          }

          .everyDayRate {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 5px 0px;
            color: #666;
          }
        }
      }

      .total {
        border-top: 1px solid #ddd;
        padding: 15px 0;
        display: flex;
        font-size: 14px;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// bookFooter.vue?564b44a8